var _desc, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCheckmarkGrey(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "18px",
    height: "17px",
    viewBox: "0 0 18 17",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "noun_done_1656248") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-98.000000, -994.000000)",
    fill: "#A0A5B5",
    fillRule: "nonzero",
    stroke: "#A0A5B5",
    strokeWidth: 0.5
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(15.000000, 859.000000)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(15.000000, 99.000000)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(69.000000, 37.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.1304348,7.73913043 C15.1304348,12 11.7391304,15.4782609 7.56521739,15.4782609 C3.39130435,15.4782609 0,12 0,7.73913043 C0,3.47826087 3.39130435,0 7.56521739,0 C9.13043478,0 10.6434783,0.486956522 11.9304348,1.40869565 C12.0869565,1.51304348 12.1217391,1.73913043 12.0173913,1.89565217 C11.9130435,2.05217391 11.6869565,2.08695652 11.5304348,1.96521739 C10.3652174,1.14782609 8.99130435,0.695652174 7.56521739,0.695652174 C3.77391304,0.695652174 0.695652174,3.86086957 0.695652174,7.73913043 C0.695652174,11.6173913 3.77391304,14.7826087 7.56521739,14.7826087 C11.3565217,14.7826087 14.4347826,11.6173913 14.4347826,7.73913043 C14.4347826,7.54782609 14.5913043,7.39130435 14.7826087,7.39130435 C14.973913,7.39130435 15.1304348,7.54782609 15.1304348,7.73913043 Z M15.8782609,1.79130435 C15.7391304,1.65217391 15.5130435,1.65217391 15.3913043,1.79130435 L8,9.37391304 L4.85217391,6.13913043 C4.71304348,6 4.50434783,6 4.36521739,6.13913043 C4.22608696,6.27826087 4.22608696,6.48695652 4.36521739,6.62608696 L7.75652174,10.1043478 C7.82608696,10.173913 7.91304348,10.2086957 8,10.2086957 C8.08695652,10.2086957 8.19130435,10.173913 8.24347826,10.1043478 L15.8956522,2.29565217 C16.0173913,2.15652174 16.0173913,1.93043478 15.8782609,1.79130435 Z"
  }))))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckmarkGrey);
export default __webpack_public_path__ + "static/media/checkmark-grey.a969d6f9ab51429d033c2a10a6c67866.svg";
export { ForwardRef as ReactComponent };